"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __spreadArrays = (this && this.__spreadArrays) || function () {
    for (var s = 0, i = 0, il = arguments.length; i < il; i++) s += arguments[i].length;
    for (var r = Array(s), k = 0, i = 0; i < il; i++)
        for (var a = arguments[i], j = 0, jl = a.length; j < jl; j++, k++)
            r[k] = a[j];
    return r;
};
Object.defineProperty(exports, "__esModule", { value: true });
var d3 = require("d3");
var _ = require("lodash");
var __1 = require("..");
var __2 = require("../..");
var element_1 = require("../../element");
var base_1 = require("./layers/base");
var geometry_1 = require("../../geometry");
var Circos = /** @class */ (function (_super) {
    __extends(Circos, _super);
    function Circos() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        /** [index][chr] */
        _this._outerRadiusForLayer = [];
        _this._layers = [];
        _this._layersForKey = {};
        return _this;
    }
    Circos.prototype.defaultOptions = function () {
        return {
            _circosRotation: 0,
            _circosRotationToSection: null,
            _padAngle: 0.0075,
            _startAngle: 0,
            _endAngle: 2 * Math.PI,
            _layerGap: 4,
            _sectionScaleFactor: {},
            _skippedSections: [],
            _sortByValue: false,
            _sortBySecOrderIndex: false,
            _sortByKeys: null,
            _showLayerLabels: false,
            _showSectionLabels: true,
            _groupDef: {},
        };
    };
    Circos.prototype._append = function (element) {
        return this._layerContainer._append(element);
    };
    Circos.prototype.init = function () {
        var _this = this;
        _super.prototype.init.call(this);
        this._container = this.appendT(__1.Component).options({
            _width: geometry_1.GeometryValue.fullSize,
            _height: geometry_1.GeometryValue.fullSize,
            _x: geometry_1.GeometryValue.fullSize,
            _y: geometry_1.GeometryValue.fullSize,
            _anchor: 4 /* Middle */ | 32 /* Center */,
            _rotation: function (d, i, g, h) { return [_this.rotation, 0, 0]; },
        });
        this._layerContainer = this._container.appendT(__1.Component);
        this._labels = this._container.appendGroupT(element_1.Text).options({
            _$beforeAll: function (d, i, g, h) {
                h.set("pos", __2.tool.polar2cart(d.angle, d.radius));
            },
            _x: function (d, i, g, h) { return h.get("pos")[0]; },
            _y: function (d, i, g, h) { return h.get("pos")[1]; },
            _rotation: function (d, i, g, h) { return _this.labelRotation.apply(_this, __spreadArrays([d.angle], h.get("pos"))); },
            _text: function (d) { return d.data.key; },
            "font-size": 12,
            fill: "#fff",
        });
        this._layerLabels = this._container.appendGroupT(__1.Component).options({
            _x: function (d) { return __2.tool.polar2cart(0, (d.innerR + d.outerR) / 2)[0]; },
            _y: function (d) { return __2.tool.polar2cart(0, (d.innerR + d.outerR) / 2)[1]; },
        });
        this._layerLabels.appendT(element_1.Text).options({
            _text: function (d) { return d.name; },
            fill: "#fff",
            "font-size": 10,
        });
    };
    Circos.prototype.prepare = function () {
        var _this = this;
        _super.prototype.prepare.call(this);
        this._layers = [];
        this._layersForKey = {};
        this._cachedWidth = this._getGeometry("_width", true);
        this._cachedHeight = this._getGeometry("_height", false);
        this.outerRadius = Math.min(this._cachedWidth, this._cachedHeight) / 2.0;
        this._labels.options("_display", this.getOption("_showSectionLabels"));
        var showLayerLabels = this.getOption("_showLayerLabels");
        this._layerLabels.options("_display", showLayerLabels);
        if (showLayerLabels) {
            this.options({
                _startAngle: __2.tool.toRad(5),
                _endAngle: __2.tool.toRad(355),
            });
        }
        var scaleFactor = this.getOption("_sectionScaleFactor");
        var pie = d3.pie()
            .padAngle(this.getOption("_padAngle"))
            .startAngle(this.getOption("_startAngle"))
            .endAngle(this.getOption("_endAngle"))
            .value(function (d) {
            var f = scaleFactor[d.key] || d.scaleFactor || 1;
            return f * (d.end - d.start);
        });
        var sortByKeys = this.getOption("_sortByKeys");
        if (sortByKeys) {
            pie.sort(function (a, b) { return sortByKeys.indexOf(a.key) - sortByKeys.indexOf(b.key); });
        }
        else if (this.getOption("_sortBySecOrderIndex")) {
            pie.sort(function (a, b) { return a.sortIndex - b.sortIndex; });
        }
        else if (!this.getOption("_sortByValue")) {
            pie.sortValues(null);
        }
        var skippedSections = new Set(this.getOption("_skippedSections"));
        var pieData = [];
        for (var _i = 0, _a = this.datum; _i < _a.length; _i++) {
            var secData = _a[_i];
            if (!skippedSections.has(secData.key)) {
                pieData.push(secData);
            }
        }
        this.parsedData = pie(pieData);
        this._angles = _.keyBy(this.parsedData, function (d) { return d.data.key; });
        this._scales = _(this.parsedData)
            .keyBy(function (d) { return d.data.key; })
            .mapValues(function (x) { return d3.scaleLinear()
            .range([__2.tool.toDeg(x.startAngle + x.padAngle), __2.tool.toDeg(x.endAngle - x.padAngle)])
            .domain([x.data.start, x.data.end]); }).value();
        // layers
        var index = 0;
        var outerRadius = _.fromPairs(this.parsedData.map(function (x) { return [x.data.key, _this.outerRadius - (x.data.inset || 0) - 30]; }));
        this._layerContainer.elements.forEach(function (x) {
            if (x instanceof base_1.Layer) {
                x.circos = _this;
                x.index = index;
                // group
                if (x.dataKeys instanceof Array) {
                    _this._outerRadiusForLayer[index] = {};
                    for (var _i = 0, _a = x.dataKeys; _i < _a.length; _i++) {
                        var key = _a[_i];
                        if (!_this._layersForKey[key]) {
                            _this._layersForKey[key] = [];
                        }
                        var localLayers = _this._layersForKey[key];
                        var localIndex = localLayers.length;
                        _this._outerRadiusForLayer[index][key] = localIndex === 0 ?
                            outerRadius[key] :
                            _this.innerRForLayer(_.last(localLayers).index, key) - x.outerGap;
                        localLayers.push(x);
                    }
                }
                _this._layers[index] = x;
                index += 1;
            }
        });
        if (showLayerLabels) {
            this._layerLabels.data(this._layers.map(function (layer, index) {
                if (!layer.dataKeys) {
                    return { innerR: 0, outerR: 0, name: _this._layers[index].getOption("_label") };
                }
                else {
                    var firstDataKey = layer.dataKeys[0];
                    return {
                        innerR: _this.innerRForLayer(index, firstDataKey),
                        outerR: _this._outerRadiusForLayer[index][firstDataKey],
                        name: _this._layers[index].getOption("_label"),
                    };
                }
            }));
        }
        // labels
        this._labels.data(this.parsedData.map(function (x) { return ({
            angle: (x.startAngle + x.endAngle) / 2 * (180 / Math.PI),
            radius: _this.outerRadius - 10,
            data: x.data,
        }); }));
    };
    Circos.prototype.removeAllLayers = function () {
        this._layerContainer.removeAllElements();
        this._layers = [];
    };
    Circos.prototype.startAndEndPosForChr = function (chr) {
        return [this.datum[chr].start, this.datum[chr].end];
    };
    Circos.prototype.xScaleForChr = function (chr) {
        return this._scales[chr];
    };
    Circos.prototype.startAngleForChr = function (chr) {
        return this._angles[chr].startAngle * 180 / Math.PI;
    };
    Circos.prototype.endAngleForChr = function (chr) {
        return this._angles[chr].endAngle * 180 / Math.PI;
    };
    Circos.prototype.padAngleForChr = function (chr) {
        return this._angles[chr].padAngle * 180 / Math.PI;
    };
    Circos.prototype.innerRForLayer = function (index, section) {
        return this.outerRForLayer(index, section) - this.thicknessForLayer(index, section);
    };
    Circos.prototype.outerRForLayer = function (index, section) {
        return this._outerRadiusForLayer[index][section];
    };
    Circos.prototype.innerRBySection = function (section) {
        return this.innerRForLayer(_.last(this._layersForKey[section]).index, section);
    };
    Circos.prototype.thicknessForLayer = function (index, section) {
        return this._layers[index].getThickness(section);
    };
    Object.defineProperty(Circos.prototype, "rotation", {
        get: function () {
            var key = this.getOption("_circosRotationToSection");
            if (key) {
                return 360 - (this.startAngleForChr(key) + this.endAngleForChr(key)) / 2;
            }
            else {
                return this.getOption("_circosRotation");
            }
        },
        enumerable: true,
        configurable: true
    });
    Circos.prototype.labelRotation = function (angle, x, y) {
        var adjustedAngle = angle + this.rotation;
        if (adjustedAngle >= 360) {
            adjustedAngle -= 360;
        }
        if (adjustedAngle < 0) {
            adjustedAngle += 360;
        }
        return [
            adjustedAngle < 180 ? angle - 90 : angle + 90,
            x, y,
        ];
    };
    Circos.prototype.labelAnchor = function (angle, towardsCenter) {
        var adjustedAngle = angle + this.rotation;
        if (adjustedAngle >= 360) {
            adjustedAngle -= 360;
        }
        if (adjustedAngle < 0) {
            adjustedAngle += 360;
        }
        return (adjustedAngle > 180 === towardsCenter ? 16 /* Left */ : 64 /* Right */) | 4 /* Middle */;
    };
    return Circos;
}(__1.Component));
exports.Circos = Circos;
//# sourceMappingURL=circos.js.map


//////////////////
// WEBPACK FOOTER
// ./node_modules/bvd3/dist/component/circos/circos.js
// module id = 1174
// module chunks = 0 1